import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 434 500",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M204.8 0a58.72 58.72 0 11-58.75 58.72A58.73 58.73 0 01204.8 0zm218.73 443.36L262.92 300.23v-112.1h116.87a27.84 27.84 0 0025.57-13.62 28.64 28.64 0 000-29.29 27.85 27.85 0 00-25.57-13.63l-350.2.5A27.86 27.86 0 004 145.72 28.69 28.69 0 004 175a27.85 27.85 0 0025.57 13.62H143.8v112.7L87 356.28a33.07 33.07 0 00-9.87 25.63L81.82 470A32.37 32.37 0 00114 500h2.18a32.15 32.15 0 0029.68-34.13l-4.33-72.64 56.86-54a33.45 33.45 0 005.36-7 37.9 37.9 0 006.32 8l170.87 151.59a31.78 31.78 0 0050.92-12.77 32.83 32.83 0 00-8.33-35.69z",
      stroke: "none"
    })]
  });
};
const IconGymFeatureClasses = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "GymFeatureClasses__IconGymFeatureClasses",
  componentId: "sc-x38mjy-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconGymFeatureClasses };
